export default __webpack_public_path__ + "static/events-dark-096d70a4955eb0c338d9df3dbbd8cfa5.png";